import type { ReactNode } from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import RouterOutlinedIcon from '@mui/icons-material/RouterOutlined';
import { CRM_VERSION } from '../layout/AppFooter';

interface AuthShellProps {
  title: string;
  subtitle: string;
  children: ReactNode;
}

export function AuthShell({ title, subtitle, children }: AuthShellProps) {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'grid',
        placeItems: 'center',
        p: 2,
        background: 'linear-gradient(160deg, #eef4fb 0%, #f6f8fb 55%, #e8f0fa 100%)',
      }}
    >
      <Box sx={{ width: '100%', maxWidth: 440 }}>
        <Stack direction="row" spacing={1.5} alignItems="center" justifyContent="center" sx={{ mb: 3 }}>
          <RouterOutlinedIcon color="primary" sx={{ fontSize: 34 }} />
          <Box>
            <Typography variant="h6" sx={{ lineHeight: 1.2 }}>
              HiveCore
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Communications Corporation
            </Typography>
          </Box>
        </Stack>

        <Card sx={{ boxShadow: '0 12px 32px rgba(21, 101, 192, 0.10)' }}>
          <CardContent sx={{ p: { xs: 3, sm: 4 } }}>
            <Typography variant="h5" component="h1" gutterBottom>
              {title}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
              {subtitle}
            </Typography>
            {children}
          </CardContent>
        </Card>

        <Typography
          variant="caption"
          color="text.secondary"
          align="center"
          display="block"
          sx={{ mt: 3 }}
        >
          © {new Date().getFullYear()} HiveCore Communications Corporation — CRM Version{' '}
          {CRM_VERSION}
        </Typography>
      </Box>
    </Box>
  );
}
